var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"logo__cell"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}})]),_c('div',{staticClass:"innobun__logo_cell"},[_c('img',{staticClass:"innobun-logo",attrs:{"src":"/src/img/innobun_fortisa.svg"}}),_c('h2',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }